import React from 'react';
import InputForm from '../../../../InputT';
import Params from '../../../../../Types/ParamsPicklist';
import { Box, Grid } from '@mui/material';
import SearchModal from '../../../../SearchModal';
import SearchInput from '../../../../SearchInput';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

// Paramètres de recherche
let searchParamsIjarah: ParamsPicklist = {
  CodeAgence: '',
  Table: "ParamsIjara",
  Colonne1: "CodeIjara",
  Colonne2: "LibelleIjara",
  Colagence: '101',
  Choix: 22
};
let searchIndice: Params = {
  CodeAgence: '',
  Table: "CLIENT",
  Colonne1: "NUMCLI",
  Colonne2: "NOMCLI",
  Colagence: '101',
  Choix: 22
};
let searchPeriod: Params = {
  CodeAgence: '',
  Table: "v_period_lib",
  Colonne1: "CODLIB",
  Colonne2: "LIBELL",
  Colagence: '101',
  Choix: 22
};
let searchSimul: Params = {
  CodeAgence: '',
  Table: "SimulationIjara",
  Colonne1: "CodeSimul",
  Colonne2: "Nomcli",
  Colagence: '101',
  Choix: 22
};

function Tab1(props: { form?: any, disabled?: boolean, GetTypeCard: Function }) {
  return (
    <div className='tabItem'>
      <Box sx={{ width: '85%' }}>
        <Grid container >
          {/* Code Simul */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <SearchInput
            width={8}
              dissabledCode={props.disabled}
              notRequired
              enable
              form={props.form}
              Titre='Recherche Simulation'
              label='Code Simul'
              name='CodeSimul'
              Parametre={searchSimul}
            />
          </Grid>

          {/* Indice Client */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <SearchInput
            width={8}
              dissabledCode={!props.disabled}
              dissabledLib={!props.disabled}
              form={props.form}
              Titre='Recherche Client'
              label='Indice Client'
              name='Numcli'
              Parametre={searchIndice}
            />
          </Grid>

          {/* Code Ijarah */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <SearchModal
            width={8}
              ExecuteafterSelect1={props.GetTypeCard}
              form={props.form}
              Titre='Type de Ijara'
              label='Code Ijara'
              name='CodeIjara'
              Parametre={searchParamsIjarah}
            />
          </Grid>

          {/* Périodicité */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <SearchModal
            width={8}
              form={props.form}
              Titre='Recherche Périodicité'
              label='Périodicité'
              name='Periodicite'
              Parametre={searchPeriod}
            />
          </Grid>

          {/* Nombre Échéance */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label='Nombre Échéance'
              name='NombreEch'
              type='number'
            />
          </Grid>

          {/* Coût d'acquisition */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label="Coût d'acquisition du bien"
              name='CoutAcquisitionBien'
              type='number'
            />
          </Grid>

          {/* Marge Locative */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label="Marge Locative"
              name='MargeLocative'
              type='number'
            />
          </Grid>

          {/* Valeur Résiduelle */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label="Valeur Résiduelle"
              name='ValeurResiduelle'
              type='number'
            />
          </Grid>

          {/* Durée Contrat */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
              width={8}
              money
              label="Durée Contrat (mois)"
              name='DureeContratMois'
              type='number'
            />
          </Grid>

          {/* Durée Différé */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
              width={8}
              money
              label="Durée Différé (mois)"
              name='DureeDiffereMois'
              type='number'
            />
          </Grid>

          {/* Frais de service (lecture seule) */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label="Frais de service"
              name='MontantFrais'
              type='number'
              disabled
              notRequired
            />
          </Grid>

          {/* Montant Charge */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              money
              label="Montant Charge"
              name='MontantCharge'
              type='number'
            />
          </Grid>

          {/* Date 1ère Échéance */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <InputForm
            width={8}
              label="Date 1ère Échéance"
              name='DatePremEch'
              type='date'
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default Tab1;